<template>
  <div class="uebersicht">
    <div class="columns">
      <div class="column" style="text-align:left;">
          <router-link style="min-width:180px" class="button is-primary" to="/spielart">Neue Spielart</router-link>
      </div>
      <div class="column">

      </div>
      <div class="column">

      </div>
      <div class="column">
        <b-field>
            <b-input placeholder="Suche..."
                type="search"
                icon="magnify"
                 v-model="search">
            </b-input>
        </b-field>
      </div>
    </div>
    <b-table :data="data" :loading="loading" checkable hoverable>
      <template slot-scope="props">
        <b-table-column field="id" label="ID" sortable>
            {{ props.row.id }}
        </b-table-column>
				<b-table-column field="name" label="Name" sortable>
          <b-tooltip  :label="showDescription(props.row.description)" multilined dashed>
            {{ props.row.name }}
          </b-tooltip>
        </b-table-column>
        <b-table-column  field="conversion" label="Conversion Fallback" sortable>
          {{ props.row.conversion}}
        </b-table-column>
        <b-table-column field="conversion0To299" label="Conversion Gruppe 0-299" sortable>
          {{ props.row.conversion0To299 }}
        </b-table-column>
        <b-table-column field="conversion300To999" label="Conversion Gruppe 300-999" sortable>
          {{ props.row.conversion300To999 }}
        </b-table-column>
        <b-table-column field="conversion1000To2999" label="Conversion Gruppe 1.000-2.999" sortable>
          {{ props.row.conversion1000To2999 }}
        </b-table-column>
        <b-table-column field="conversion3000Plus" label="Conversion Gruppe ab 3.000" sortable>
          {{ props.row.conversion3000Plus }}
        </b-table-column>
        <b-table-column  field="code" label="Code" sortable>
            {{ props.row.code}}
        </b-table-column>


      <b-table-column width="115" custom-key="actions">
        <button  style="border:0px;margin-right:7px;" class="button is-small" @click="editItem(props.row)">
        <b-icon type="is-primary" icon="pencil"></b-icon>
        </button>
         <button style="border:0px;" class="button is-small" @click="deleteItem(props.row)" :disabled="props.row.inuse">
        <b-icon type="is-danger" icon="delete"></b-icon>
        </button>
      </b-table-column>
    </template>

    <!--<template slot="detail" slot-scope="props">
      <tabledetail :row="props.row"></tabledetail>
    </template>-->

    <template slot="empty">
              <section class="section">
                  <div class="content has-text-grey has-text-centered">
                      <p>
                          <b-icon
                              icon="emoticon-sad"
                              size="is-large">
                          </b-icon>
                      </p>
                      <p>Keine Spielarten gefunden.</p>
                  </div>
              </section>
          </template>

      </b-table>
    </b-table>
  </div>
</template>

<script>
// @ is an alias to /src

const axios = require('axios');

export default {
  name: "home",
  components: {
  //  HelloWorld
},
data() {
      return {
          search: "",
          loading: true,
          data: [],
          allData: [] //Für Suchfunktion nötig
      }
  },
  watch: {
    search: function(val) {
      console.log("Suche");
      console.log(val);
      console.log(this.allData);
      val = val.toLowerCase();

      this.data =  _.filter(this.allData, function(obj) {
        var name = obj.name;
        name = name.toLowerCase();
        var code = obj.code;
        code = code.toLowerCase();
        if (name.indexOf(val) >= 0) {
         return true;
        }
        if (code.indexOf(val) >= 0) {
         return true;
        }
      });
    },
  },
  mounted: function () {
    this.loadItems();
  },
  methods: {
    showDescription: function(html) {
      var stripedHtml = html.replace(/<[^>]+>/g, ' ');
      stripedHtml = stripedHtml.replace("&nbsp;", ' ');
      return  stripedHtml;
    },
    loadItems: function() {
      //Get-Game
      var _this = this;
      _this.loading = true;
      axios.get('/api/categories', {
      withCredentials: true,
      })
      .then(function (response) {
        console.log(response.data);
        _this.data = response.data;
        _this.allData = response.data;
        _this.loading = false;
      })
      .catch(function (error) {
        console.log(error);
          _this.loading = false;
      })
      .then(function () {
        // always executed
      });

    },
    deleteItem: function(item) {
      console.log("DELETE "+item.id);
      console.log(this.search);
      var vm = this;
      this.$buefy.dialog.confirm({
        title: 'Spielart löschen',
        message: 'Soll die Spielart wirklich gelöscht werden?',
        confirmText: 'Spielart löschen',
        type: 'is-danger',
        hasIcon: true,
        cancelText: 'Abbrechen',
        onConfirm: function() {
          console.log(vm.search);
          axios.delete('/api/categories/'+item.id, {
            withCredentials: true,
          })
          .then(function (response) {
            console.log(response.data);
             vm.$buefy.toast.open('Die Spielart wurde gelöscht!');
             vm.loadItems();
          })
          .catch(function (error) {

          })
          .then(function () {
            // always executed
          });

         }
       })
    },

    editItem: function(item) {
      console.log("EDIT "+item.id);
      this.$router.push({ name: 'editcategory', params: { id: item.id } })
    }
  }
};
</script>
